import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { apiService } from '../../../services/apiService';
import { useNavigate, useParams } from 'react-router-dom';
import 'react-phone-number-input/style.css'
import { toast } from 'react-toastify';
import { Modal, Tab, Tabs } from 'react-bootstrap';
import SameDomainRecuriters from './SameDomainRecuriters';
function ItRecruiterShow() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [datasFetch, setDatasFetch] = useState({});

    const fetchRecruiterData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await apiService.getRequest(`/c2c/recruiters/${id}`);

            setDatasFetch(response?.data);

        } catch (error) {
            
        }finally {
            setLoading(false);
        }
    }, [id]);
    useEffect(() => {
        fetchRecruiterData();
    }, [fetchRecruiterData]);


    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };
    const handleDelete = async () => {
        try {
            const response = await apiService.deleteRequest(`/c2c/recruiters/${id}`);
            if (response && response.success === true) {
                toast(response.message || "Deleted successfully");
                navigate("/recruiter/it-recruiter");
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {

        }
        handleClose();
    };
    
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container justifyContent="center" className="main_jobseeker">
                <Grid size={{xs:12}} container alignItems="center">
                    <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>C2C</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/recruiter/it-recruiter")}>C2C</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/recruiter/it-recruiter")}>IT Recruiter</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {datasFetch.formatted_id}</span>
                    </Grid>
                </Grid>
                {loading ? 
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :<>
                    <Grid size={{xs:12}} container justifyContent="flex-end" className="gap-3 my-3">
                        <button className='registersendbtn1 my-0' onClick={()=>navigate("/recruiter/it-recruiter")}>Back</button>
                        <button className='registersendbtn1 my-0' onClick={() => handleShow()}>Delete</button>
                        <button className='registersendbtn2 my-0' onClick={()=>navigate(`/recruiter/it/edit/${id}`)}>Edit</button>
                    </Grid>
                    <Grid size={{sm:11,xs:12}} container justifyContent="space-between" className="regiter_inputs i94validateinput">
                        <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                            <span>Name</span>
                            <p>{datasFetch.name}</p>
                        </Grid>
                        <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                            <span>Email Id<small className='red_starimpo'>*</small></span>
                            <p>{datasFetch.email}</p>
                        </Grid>
                        <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                            <span className='mt-0'>Phone Number</span>
                            <p>{datasFetch.phone_number}</p>
                        </Grid>
                        <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="regiter_inputs mb-4">
                            <span className='mt-0'>Accuracy</span>
                            <p>{datasFetch.accuracy}</p>
                        </Grid>
                    </Grid>
                    <Grid size={{sm:11,xs:12}} container justifyContent="space-between" className="mt-5">
                        <Tabs
                            defaultActiveKey="domain_recuriters"
                            id="uncontrolled-tab-example"
                            className="mb-3 drafttabs_tabs"
                        >
                            <Tab eventKey="domain_recuriters" title="Internal Recruiters">
                                <SameDomainRecuriters/>
                            </Tab>
                        </Tabs>
                    </Grid>
                </>}
            </Grid>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this Recruiter?</Modal.Body>
                <Modal.Footer>
                    <button className='modal_cancel' onClick={handleClose}>
                        Cancel
                    </button>
                    <button className='modal_delete' onClick={handleDelete}>
                        Delete
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    </div>
  )
}

export default ItRecruiterShow
